import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { FilterModule } from './filter/filter.module';
import { HttpClientModule } from '@angular/common/http';
import { CourseSkeletonModule } from './course-skeleton/course-skeleton.module';

const components = [FooterComponent, HeaderComponent];
@NgModule({
  declarations: components,
  imports: [CommonModule, FilterModule, HttpClientModule, CourseSkeletonModule],
  exports: [...components, FilterModule, CourseSkeletonModule],
})
export class SharedUiComponentsModule {
  // static forRoot(): ModuleWithProviders {
  //   return {
  //     ngModule: SharedUiComponentsModule,
  //     providers: [ {provide: JQ_TOKEN, useValue: jQuery}, ]
  //   };
  // }
}
